import { useEffect, useState } from 'react';

/** Umbral de gesto: menos de esto es ruido del dedo, no intención (handoff §2). */
const UMBRAL = 8;

/**
 * "Hide on scroll down, show on scroll up": la cabecera se va con el scroll y vuelve
 * completa al primer gesto hacia arriba. Sin biblioteca a propósito.
 *
 * SSR-safe: el estado inicial es `visible` en server y cliente, el listener entra recién
 * en `useEffect` (post-hidratación) y el render nunca lee `window`. El ocultamiento es
 * `transform` + `transition` CSS del lado de la vista: cero layout, cero CLS.
 */
export function useCabeceraOculta(): boolean {
  const [oculta, setOculta] = useState(false);

  useEffect(() => {
    let anterior = window.scrollY;
    let ocultaActual = false;

    const onScroll = () => {
      const actual = window.scrollY;
      const delta = actual - anterior;
      if (Math.abs(delta) < UMBRAL) return;
      anterior = actual;

      // Arriba de todo siempre se ve; bajando se esconde; subiendo vuelve.
      const debeOcultarse = delta > 0 && actual > 64;
      if (debeOcultarse !== ocultaActual) {
        ocultaActual = debeOcultarse;
        setOculta(debeOcultarse);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return oculta;
}
